export function trimEndChars(str, chars) {
    while (chars.includes(str.charAt(str.length - 1))) {
        str = str.substring(0, str.length - 1);
    }
    return str;
}
export function trimStartChars(str, chars) {
    while (chars.includes(str.charAt(0))) {
        str = str.substring(1);
    }
    return str;
}
export function stripNonNumeric(str) {
    return str.replace(/\D/g, '');
}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
